import { render, staticRenderFns } from "./MatchingGame.vue?vue&type=template&id=296829c3&scoped=true&"
import script from "./MatchingGame.vue?vue&type=script&lang=js&"
export * from "./MatchingGame.vue?vue&type=script&lang=js&"
import style0 from "./MatchingGame.vue?vue&type=style&index=0&id=296829c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296829c3",
  null
  
)

export default component.exports